import styled from 'styled-components';

export default styled.div`
    text-align: center;
    margin: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    .hidden-input {
        display: none;
    }
    .file-input-wrapper {
        display: inline-block;
        margin-bottom: 16px;
        label {
            display: inline-block;
        }
        input {
            display: none;
        }
    }
    .status {
        margin-top: 16px;
        padding: 12px;
        background-color: hsl(0, 0%, 98%);
        border: 1px solid hsl(0, 0%, 95%);
        border-radius: var(--base-border-radius);
        display: flex;
        justify-content: center;
        align-items: center;
        width: fit-content;
        .label {
            font-size: 1.2rem;
        }
        .icon {
            margin-left: 8px;
            width: 14px;
            height: 14px;
        }
        &--uploading {
            .icon {
                width: 32px;
                height: 32px;
            }
        }
        &--uploaded {
            color: var(--color-success);
            .icon {
                filter: var(--filter-success);
            }
        }
        &--error {
            color: var(--color-error);
            .icon {
                filter: var(--filter-error);
            }
        }
    }
    .error-message {
        display: none;
        padding: 8px;
        border-radius: 4px;
        color: var(--color-danger);
        border: 1px solid var(--color-danger);
    }
    .croppie-container {
        .cr-boundary {
            width: 100% !important;
            max-width: ${props => props.config.width + 'px'} !important;
        }
        .cr-slider-wrap {
            width: 100%;
        }
        .cr-slider {
            width: 100%;
            max-width: ${props => props.config.width + 'px'};
            -webkit-appearance: none;
            &::-webkit-slider-thumb {
                background-color: var(--color-secondary);
                cursor: pointer;
            }
            &::-webkit-slider-runnable-track {
                background-color: var(--color-gray-lighter);
            }
        }
    }
    .preview-wrapper {
        img {
            margin-bottom: 16px;
        }
    }
    &.step-one {
        .preview-wrapper, .crop-button  {
            display: none;
        }
    }
    &.step-two {
        .preview-wrapper {
            display: none;
        }
    }
    &.step-three {
        .select-and-crop-wrapper {
            display: none;
        }
    }
    &.has-error {
        .error-message {
            display: block;
        }
        .cropper-element, .crop-button, .preview-wrapper {
            display: none;
        }
    }
`;